// extracted by mini-css-extract-plugin
export default {"ExecutiveSummary":"ExecutiveSummary_ExecutiveSummary__JU8jO","Section":"ExecutiveSummary_Section__I3EMi","SubSection":"ExecutiveSummary_SubSection__PK8bm"};